import { render, staticRenderFns } from "./ChatEmoji.vue?vue&type=template&id=574aa680&"
import script from "./ChatEmoji.vue?vue&type=script&lang=js&"
export * from "./ChatEmoji.vue?vue&type=script&lang=js&"
import style0 from "./ChatEmoji.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports